import { avaiableSearchTypes } from "../search-page-util";
import {
  FolderPatternParams,
  GdriveParams,
  MetadataParams,
} from "./data-types-search-page";

interface SearchUrlSearchParameters {
  container: string;
  search: string;
  folderPatternParams: FolderPatternParams | undefined;
  gdriveParams: GdriveParams | undefined;
  metadataParams: MetadataParams | undefined;
  limit: string;
}

export class SearchPageSearchParameters implements SearchUrlSearchParameters {
  container: string;
  search: string;
  folderPatternParams: FolderPatternParams | undefined;
  gdriveParams: GdriveParams | undefined;
  metadataParams: MetadataParams | undefined;
  limit: string;

  constructor(
    aContainer: string,
    aSearch: string,
    aFolderPattern: FolderPatternParams | undefined,
    aGdrive: GdriveParams | undefined,
    aMetadata: MetadataParams | undefined,
    aLimit: string
  ) {
    this.container = aContainer;
    this.search = aSearch;
    this.folderPatternParams = aFolderPattern;
    this.gdriveParams = aGdrive;
    this.metadataParams = aMetadata;
    this.limit = aLimit;
  }

  public updateSearchParamsByUrl = (searchParams: URLSearchParams) => {
    this.container = searchParams.get("container") ?? "";
    this.search = searchParams.get("search") ?? "";
    this.limit = searchParams.get("limit") ?? this.limit;
    switch (this.search) {
      case avaiableSearchTypes[0]:
        //metadata
        const metaDataKey = searchParams.get("metadata.metaDataKey") ?? "";
        const metaDataValue = searchParams.get("metadata.metaDataValue") ?? "";
        const folder = searchParams.get("metadata.folder") ?? "";
        this.metadataParams = getMetadataParams(
          metaDataKey,
          metaDataValue,
          folder
        );
        this.folderPatternParams = undefined;
        this.gdriveParams = undefined;
        break;
      case avaiableSearchTypes[1]:
        //gdrive
        const GdriveLink = searchParams.get("gdrive.GdriveLink") ?? "";
        this.gdriveParams = getGdriveParams(GdriveLink);
        this.metadataParams = undefined;
        this.folderPatternParams = undefined;
        break;
      case avaiableSearchTypes[2]:
        //folder pattern
        const folderPattern = searchParams.get("pattern.folderPattern") ?? "";
        const fileName = searchParams.get("pattern.fileName") ?? "";
        this.folderPatternParams = getFolderPatternParams(folderPattern, fileName);
        this.metadataParams = undefined;
        this.gdriveParams = undefined;
        break;
    }
  };

  public resetSearchTypesProperties = () => {
    this.metadataParams = undefined;
    this.folderPatternParams = undefined;
    this.gdriveParams = undefined;
  };

  public setSearchTypesProperties = (
    inputData: FolderPatternParams | GdriveParams | MetadataParams
  ) => {
    switch (true) {
      case inputData instanceof FolderPatternParams:
        this.resetSearchTypesProperties();
        this.folderPatternParams = inputData as FolderPatternParams;
        break;
      case inputData instanceof GdriveParams:
        this.resetSearchTypesProperties();
        this.gdriveParams = inputData as GdriveParams;
        break;
      case inputData instanceof MetadataParams:
        this.resetSearchTypesProperties();
        this.metadataParams = inputData as MetadataParams;
        break;
    }
  };
}

const getFolderPatternParams = (folderPattern?: string, fileName?: string): FolderPatternParams => {
  return new FolderPatternParams(folderPattern, fileName);
};

const getGdriveParams = (tagSearchQuery: string): GdriveParams => {
  return new GdriveParams(tagSearchQuery);
};

const getMetadataParams = (
  metaDataKey: string,
  metaDataValue: string,
  folder: string | undefined
): MetadataParams => {
  return new MetadataParams(metaDataKey, metaDataValue, folder);
};
